import { makeGetEntities } from "../../redux/selectors/selectors";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../redux/actions/usersActions";

const selector = makeGetEntities();

export function useUsers() {
  const dispatch = useDispatch();
  const fetchUsers = () => {
    dispatch(fetchEmployees());
  };

  const { users, loading: isLoading } = useSelector(({ usersState }) => {
    return {
      users: selector(usersState.publicData.users, {
        type: "user"
      }),
      loading: usersState.loading
    };
  });

  return { users, fetchUsers, isLoading };
}
